module.exports = __webpack_public_path__ + "04b5559ba8737bb0152446d1f9dbfe3a.svg";